import { useState } from "react";
export const COLORS = {
    BLACK: "#000000",
    WHITE: "#ffffff",
    GREEN: "#00FF00",
    BLUE: "#0000FF"
};
export const STROKES = {
    THIN: 2,
    MEDIUM: 6,
    THICK: 16
};
export const FONT_SIZES = {
    SMALL: 30,
    MEDIUM: 50,
    LARGE: 80
};
export function useToolPanel(excalidrawApi) {
    const [currentColor, setCurrentColor] = useState(COLORS.BLACK);
    const [currentStroke, setCurrentStroke] = useState(STROKES.THIN);
    const [currentFontSize, setCurrentFontSize] = useState(FONT_SIZES.SMALL);
    return {
        color: {
            value: currentColor,
            set: (color) => {
                excalidrawApi.updateScene({
                    appState: {
                        currentItemStrokeColor: color
                    }
                });
                setCurrentColor(color);
            }
        },
        stroke: {
            value: currentStroke,
            set: (stroke) => {
                excalidrawApi.updateScene({
                    appState: {
                        currentItemStrokeWidth: stroke
                    }
                });
                setCurrentStroke(stroke);
            }
        },
        fontSize: {
            value: currentFontSize,
            set: (fontSize) => {
                excalidrawApi.updateScene({
                    appState: {
                        currentItemFontSize: fontSize
                    }
                });
                setCurrentFontSize(fontSize);
            }
        }
    };
}
